import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const IconButton = ({
  styleName,
  onTouchStart,
  onClick,
  children,
  disabled,
  ariaLabel,
}) => (
  <div className="IconButton">
    <button
      className={classNames('IconButton__button', `${styleName}-wrapper`, {
        'IconButton--disabled': disabled,
      })}
      onTouchStart={onTouchStart}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <span className="IconButton__contents">
        <div
          className={classNames('IconButton__icon', styleName, {
            'IconButton--disabled': disabled,
          })}
        />
        {children}
      </span>
    </button>
  </div>
);

IconButton.propTypes = {
  styleName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  disabled: false,
};

export default IconButton;
